import gql from 'graphql-tag';

export default gql`
  fragment responseStatusChangeActivityFragment on ResponseStatusChangeActivity {
    responseStatus
    responseStatusText
  }
`;
